import React from 'react';
import { Card } from './Card';
import cx from 'classnames';
export const CardSingle = ({ title, description }) => {
    return (React.createElement(Card, null,
        React.createElement("div", { className: "card-single" },
            React.createElement("div", { className: "card-single_content" },
                React.createElement("h6", { className: cx('card-single_title', { 'card-single_title--loading': !title }) }, title),
                React.createElement("p", { className: cx('card-single_description', {
                        'card-single_description--loading': !description,
                    }) }, description)))));
};
//# sourceMappingURL=CardSingle.js.map